/**
 * Locked NCBE trademark / non-affiliation disclaimer.
 *
 * Canonical text governed by docs/brand/nextgen-ncbe-canonical-facts.md §11
 * (founder-approved 2026-07-03). Reproduce verbatim — do not paraphrase.
 * The Astro blog duplicates this string in blog/src/components/BlogFooter.astro;
 * keep both in sync when the locked text changes.
 *
 * Note: this line does NOT satisfy the license §VII.A/§VII.B notices required
 * on surfaces that display NCBE-licensed content — those carry their own
 * verbatim texts (see docs/nextgen/ncbe-official-questions/research/09).
 */
export const NCBE_TRADEMARK_DISCLAIMER =
  'NCBE®, MBE®, MEE®, MPRE®, MPT®, UBE®, and NextGen UBE are trademarks or service marks of the National Conference of Bar Examiners (NCBE). JD Simplified is neither endorsed by nor affiliated with NCBE.';

interface NcbeDisclaimerProps {
  /** 'footer' = small muted line for the dark marketing footer; 'page' = body copy on light/dark pages */
  variant?: 'footer' | 'page';
  className?: string;
}

export function NcbeDisclaimer({ variant = 'page', className = '' }: NcbeDisclaimerProps) {
  const base =
    variant === 'footer'
      ? 'text-gray-400 text-xs leading-relaxed'
      : 'text-gray-500 dark:text-gray-400 text-sm leading-relaxed';
  return <p className={`${base} ${className}`.trim()}>{NCBE_TRADEMARK_DISCLAIMER}</p>;
}
